/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardExtra } from '../../../Shared/Card'
import { Link } from 'react-router-dom-v5-compat'
import { Icon } from 'semantic-ui-react'
import React from 'react'
import { getMissedMetrics } from '../../../../../services/Metrics/Metrics.service'
import { getCancellationSource } from '../../../../../services/http-client'
import { isProviderAPos } from '../../../../../services/Provider/Provider.service'
import { formatISO, roundToNearestMinutes, startOfDay } from 'date-fns'
import { useQuery } from '@tanstack/react-query'
import useUser from '../../../../Shared/UserProvider/useUser'
import { LoadingPlaceholderCardContent } from './LoadingPlaceholderCardContent'
import { NegativeActivityCardContent } from './NegativeActivityCardContent'
import { NoNegativeActivityCardContent } from './NoNegativeActivityCardContent'


const NegativeActivityCard = () => {
    const from = formatISO(startOfDay(new Date()))
    const to = formatISO(roundToNearestMinutes(new Date(), {nearestTo: 5, roundingMethod: 'floor'}))
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['negative-metrics', from, to],
        queryFn: async () => await getMissedMetrics({
            dateRange: {
                startDate: from,
                endDate: to,
            },
            merchantId: isProviderAPos(user.provider) ? user.provider.object.id : null,
            brandIds: [],
            platformIds: [],
        }, getCancellationSource()),
    })

    const metrics = data?.byDate[0]
    const revenuesMissed = metrics?.revenuesMissed || 0
    const missedOrder = metrics?.missedorder || 0
    const noNegativeActivity = revenuesMissed === 0 && missedOrder === 0

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        return noNegativeActivity ? '#22c55e' : '#dc2626'
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};
            .card-content {
                width: 283px;
                height: 175px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : (
            noNegativeActivity ? (
              <NoNegativeActivityCardContent />
            ) : (
              <NegativeActivityCardContent
                revenuesMissed={revenuesMissed}
                missedOrder={missedOrder}
              />
            )
          )}
          <CardExtra>
              <Link
                to={{
                    pathname: '/analytics/missed',
                }}>
                  CA non acquis
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { NegativeActivityCard }
